import { wrapColumn, wrapRow } from './shared.js';
import { SharedBigRoad } from './shared-big-road.js';
import { DownRoad, generateDownRoadData, } from './down-road.js';

function generateSmallRoadItemList(bigRoadItemGraph) {
    return generateDownRoadData(bigRoadItemGraph, 2);//DownRoadGap.SmallRoadGap);
}
function generateSmallRoadGraph(bigRoadGraph, rowCount, columnCount) {
    return wrapRow(wrapColumn(generateSmallRoadItemList(bigRoadGraph), (previousItem, currentItem) => previousItem.repetition === currentItem.repetition), rowCount, columnCount);
}

class SmallRoad extends DownRoad {
    constructor(row, column, roundResults) {
        super(row, column, roundResults);
        this.row = row;
        this.column = column;
        this.roundResults = roundResults;
        const bigRoad = new SharedBigRoad(row, roundResults.length, roundResults);
        this.array = generateSmallRoadGraph(bigRoad.rawArray, row, column);
    }
    get bankerPrediction() {
        const fakeNextRound = {
            order: this.roundResults.length,
            result: 0, // Dummy
            gameResult: 1,//GameResult.BankerWin,
            pairResult: 0,//PairResult.NoPair,
        };
        return this.getPrediction(fakeNextRound, 2);//DownRoadGap.SmallRoadGap);
    }
    get playerPrediction() {
        const fakeNextRound = {
            order: this.roundResults.length,
            result: 0, // Dummy
            gameResult: 2,//GameResult.PlayerWin,
            pairResult: 0,//PairResult.NoPair,
        };
        return this.getPrediction(fakeNextRound, 2);//DownRoadGap.SmallRoadGap);
    }
}

// 새로운 SuperSmallRoad 클래스 추가
class SuperSmallRoad {
    constructor(smallRoadArray) {
        if (!Array.isArray(smallRoadArray) || smallRoadArray.length === 0) {
            console.error('Invalid smallRoadArray:', smallRoadArray);
            this.smallRoadArray = [];
        } else {
            this.smallRoadArray = smallRoadArray;
        }
    }

    get superSmallRoadBankerPrediction() {
        return this.getSuperPrediction(1); // 1 for BankerWin
    }

    get superSmallRoadPlayerPrediction() {
        return this.getSuperPrediction(2); // 2 for PlayerWin
    }

    getSuperPrediction(gameResult) {
        if (this.smallRoadArray.length === 0) {
            console.log('Empty smallRoadArray, cannot make prediction');
            return undefined;
        }

        const lastNonEmptyColumn = this.findLastNonEmptyColumn();
        if (lastNonEmptyColumn === -1) return undefined;

        const fakeNextItem = { repetition: true, gameResult: gameResult };
        const fakeSmallRoadArray = this.smallRoadArray.map(row => [...row]);
        
        if (fakeSmallRoadArray[0][lastNonEmptyColumn + 1] === undefined) {
            // Add to a new column
            fakeSmallRoadArray.forEach(row => row.push(undefined));
            fakeSmallRoadArray[0][lastNonEmptyColumn + 1] = fakeNextItem;
        } else {
            // Add to the existing column
            const lastEmptyRowIndex = fakeSmallRoadArray.findIndex(row => row[lastNonEmptyColumn + 1] === undefined);
            if (lastEmptyRowIndex !== -1) {
                fakeSmallRoadArray[lastEmptyRowIndex][lastNonEmptyColumn + 1] = fakeNextItem;
            } else {
                // If the column is full, add to a new column
                fakeSmallRoadArray.forEach(row => row.push(undefined));
                fakeSmallRoadArray[0][lastNonEmptyColumn + 2] = fakeNextItem;
            }
        }

        const newLastNonEmptyColumn = this.findLastNonEmptyColumn(fakeSmallRoadArray);
        if (newLastNonEmptyColumn === -1) return undefined;

        if (newLastNonEmptyColumn < 2) return undefined;

        const currentColumn = fakeSmallRoadArray.map(row => row[newLastNonEmptyColumn]).filter(item => item !== undefined);
        const twoColumnsBack = fakeSmallRoadArray.map(row => row[newLastNonEmptyColumn - 2]).filter(item => item !== undefined);

        // Compare the length of the current column with the column two steps back
        const lengthComparison = currentColumn.length === twoColumnsBack.length;

        // Check if the game result of the last item in the current column matches the predicted game result
        const lastItem = currentColumn[currentColumn.length - 1];
        const resultMatches = lastItem.gameResult === gameResult;

        // Return true if both conditions are met (length comparison and result match)
        return lengthComparison && resultMatches;
    }

    findLastNonEmptyColumn(array = this.smallRoadArray) {
        for (let j = array[0].length - 1; j >= 0; j--) {
            if (array.some(row => row[j] !== undefined)) {
                return j;
            }
        }
        return -1;
    }
}


export { SmallRoad, SuperSmallRoad }